<template>
  <div>
    <div :class="stepClass">
      <custom-input
        stop-clearfix
        :label="$t('business_listing.stepper.open_hours')"
        :label-as-a-container="false"
        :info-text="$t('business_listing.stepper.time_format')"
      >
        <!-- :error-text="errorMsg($v.step_0.businessDescription)" -->
        <div
          v-for="(day, key) in value"
          :key="key"
          class="time-picker-group"
        >
          <div>
            <input
              v-model="value[key].isOpenToday"
              type="checkbox"
            >
            <span
              :style="{color: 'black', marginLeft:'10px'}"
              class="is-size-4"
            >
              {{ $t(`days.${key}`) }}:
            </span>
          </div>
          <div
            v-if="value[key].isOpenToday"
            class="time-picker-pair"
          >
            <vue-timepicker
              v-model="value[key].open"
              format="HH:mm"
              class="is-size-4"
              :minute-interval="5"
              hide-clear-button
            />
            <vue-timepicker
              v-model="value[key].close"
              format="HH:mm"
              class="is-size-4"
              :minute-interval="5"
              hide-clear-button
            />
          </div>
          <div
            v-else
            :style="{width: '300px', textAlign: 'center'}"
          >
            <span class="is-size-3">Closed</span>
          </div>
        </div>
      </custom-input>
    </div>
    <ButtonGroup
      :show-prev-btn="!isOuterStep.first"
      :show-finish-btn="isOuterStep.last"
      @click.native="step"
    />
  </div>
</template>

<script>
import CustomInput from '@/components/Shared/CustomInput'
import VueTimepicker from 'vue2-timepicker'
import formHelperMixin from '@/mixins/form-helper'
import ButtonGroup from './ButtonGroup'

const typicalDay = {
  open: { HH: '09', mm: '00' },
  close: { HH: '17', mm: '30' },
  isOpenToday: true
}

export default {

  name: 'StepHours',
  components: {
    CustomInput,
    VueTimepicker,
    ButtonGroup
  },
  mixins: [formHelperMixin],
  props: {
    // class can't be used as a prop name, so to pass any custom classes as a
    // prop, we need to pass them in as 'stepClass'
    stepClass: {
      type: String,
      default: ''
    },
    // Check if this step is the first or last and therefore decide whether to
    // show or hide the next/prev buttons
    isOuterStep: {
      type: Object,
      default: () => ({ first: true, last: false })
    },
    // The value should be passed in as a prop, and we can use the v-model
    // directive to bind to the specific part of the passed value relevant
    // for this step
    value: {
      type: Object,
      default: () => ({
        mon: { ...typicalDay },
        tue: { ...typicalDay },
        wed: { ...typicalDay },
        thu: { ...typicalDay },
        fri: { ...typicalDay },
        sat: { ...typicalDay, isOpenToday: false },
        sun: { ...typicalDay, isOpenToday: false }
      })
    }
  },

  methods: {
    step ({ target }) {
      if (target.id === 'next-btn') {
        this.$emit('next', this.$v)
      } else if (target.id === 'prev-btn') {
        this.$emit('prev')
      }
    }
  }
}
</script>

<style lang="css" scoped>
</style>
